import { render, staticRenderFns } from "./CdArrivalIcon.vue?vue&type=template&id=0c55570a&scoped=true&"
var script = {}
import style0 from "./CdArrivalIcon.vue?vue&type=style&index=0&id=0c55570a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55570a",
  null
  
)

export default component.exports